import { getMissingContact } from '../../../LambdaFunctions/shared/personalContact';

export const CONTACT_FILTERS = [
  ['all', 'Wszyscy'],
  ['missingMobile', 'Brak telefonu'],
  ['missingEmail', 'Brak e-maila'],
  ['missingAny', 'Brak co najmniej jednego'],
  ['missingBoth', 'Brak obu'],
];

export const normalizeContactFilter = value => (value !== 'missingAny' && CONTACT_FILTERS.some(([key]) => key === value) ? value : 'all');

export const normalizeNotificationFilter = value => (['enabled', 'disabled'].includes(value) ? value : 'all');

export function matchesContactFilter(person, filter) {
  const { missingEmail, missingMobile } = getMissingContact(person);
  switch (filter) {
    case 'missingEmail': return missingEmail;
    case 'missingMobile': return missingMobile;
    case 'missingAny': return missingEmail || missingMobile;
    case 'missingBoth': return missingEmail && missingMobile;
    default: return true;
  }
}
